<template>
  <div>
    <div :style="{ backgroundImage: 'url('+background+')', backgroundSize: 'cover', backgroundPosition: 'center'}">
      <b-container class="py-5">
        <b-row class="p-5">
          <b-col cols="12" class="text-left m-4 p-5">
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="text-header">
      <b-container fluid class="px-5">
        <b-row class="px-3">
          <b-col cols="12" class="text-left pt-3">
            <h2 class="bolder h1">¡Hola {{user.name}}!</h2>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
  export default {
  name: "Header",
  data() {
    return {
      user: this.$auth.user(),
    }
  },
  mounted() {

  },
  computed: {
    menuTitle() {
      switch (this.$route.name) {
        case 'information':
          return 'Mis Datos';
        case 'quote':
          return 'Cotizar';
        case 'myquotes':
          return 'Mis Cotizaciones';
        case 'index':
          return 'Mi Depto';
        default:
          return 'Menú';
      }
    },
    background() {
      return this.$store.getters.getCustomerData ? this.$store.getters.getCustomerData.header_background : null;
    },
    headerText(){
      return this.$store.getters.getCustomerData ? this.$store.getters.getCustomerData.header_text : null;
    }
	},
};
</script>
<style>
	.navbar {
		background: rgba(183, 183, 183, 0.66);
	}
</style>
